import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import menu from "./menu";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    bemvindo: menu.bemvindo,
    sobre1: menu.sobre1,
    sobre2: menu.sobre2,
    sobre3: menu.sobre3,
    sobre4: menu.sobre4,
    sobre5: menu.sobre5,
    blog: menu.blog,
    hospedagem: menu.hospedagem,
    gracillis: menu.gracillis,
    bambu: menu.bambu,
    ceramica: menu.ceramica,
    artesanato: menu.artesanato,
    experiencias: menu.experiencias,
    experiencias2: menu.experiencias2,
    experiencias3: menu.experiencias3,
    experiencias4: menu.experiencias4,
    contato: menu.contato,

    versao: process.env.VUE_APP_VERSAO,
    drawer: null //utilizado para mostrar e esconder o menu
  },
  mutations
});
